import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error("auth failed");
        const user = await res.json();
        navigate("/admin", { replace: true, state: { user } });
      } catch {
        navigate("/admin", { replace: true, state: { authError: true } });
      }
    })();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-navy-deep flex items-center justify-center" data-testid="auth-callback">
      <Loader2 className="w-8 h-8 text-electric animate-spin" />
    </div>
  );
}
